import React from 'react';
import { useTranslation } from 'react-i18next';

const TopBar: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-primary text-white py-2 px-4 text-center text-sm font-medium">
            <p>{t('common.freeShippingPromo')}</p>
        </div>
    );
};

export default TopBar;
